/**
 * Merge a list of variable-names into a map[recordId] = string[],
 * always keeping them unique.
 */
// eslint-disable-next-line import/prefer-default-export
export const accumulate = (
  store: Record<string, string[]>,
  names: string[] | null | undefined,
  recordId: string,
): void => {
  if (!names?.length) return;
  // grab the old list (or empty), spread in the new ones, de-dup with Set
  // eslint-disable-next-line no-param-reassign
  store[recordId] = Array.from(
    new Set([...(store[recordId] ?? []), ...names]),
  );
};
